module.exports = __webpack_public_path__ + "img/go_guidance.df920ebb.png";